import React, {Component} from "react";
import Header from "../../components/Header";
import ScrollToTopOnMount from "../../ScrollToTopOnMount";
import PrivacyPolicyContent from "./PrivacyPolicyContent";

class Privacy extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div>
                <ScrollToTopOnMount>
                    <Header history={this.props.history} />
                    <PrivacyPolicyContent />
                </ScrollToTopOnMount>
            </div>
        )
    }
}

export default Privacy;
